import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { switchMap, takeUntil, map, catchError } from 'rxjs/operators';

import { getStayReasons$ } from 'api/axp';
import {
	fetchStayReasons,
	fetchStayReasonsFulfilled,
	fetchStayReasonsCancel,
	fetchStayReasonsFailed,
} from './stayReasons.slice';

const fetchStayReasonsEpic = (action$, state$) =>
	action$.pipe(
		ofType(fetchStayReasons.type),
		switchMap(() =>
			getStayReasons$(state$).pipe(
				map(fetchStayReasonsFulfilled),
				catchError(error => of(fetchStayReasonsFailed(error))),
				takeUntil(action$.pipe(ofType(fetchStayReasonsCancel.type)))
			)
		)
	);

export default fetchStayReasonsEpic;
